/**
 * Identity marks for a chat participant, shared by both portals so a colleague
 * is the same two letters and the same colour everywhere they appear.
 */

/**
 * Initials for an avatar. One implementation for every portal and the mobile
 * app, kept framework-free in `@munifocus/utils`.
 */
export { initialsOf } from '@munifocus/utils';

/**
 * How many tints an avatar palette must provide. Kept here so the two portals
 * cannot disagree about the range and land the same person on different colours.
 */
export const AVATAR_SLOTS = 5;

/**
 * A stable tint index for a participant.
 *
 * Keyed on the user id, not the display name: a rename must not recolour
 * someone mid-thread, and two people who share a name still need telling apart.
 * The hash only has to be stable and evenly spread — it is choosing a colour,
 * not securing anything.
 */
export function avatarSlot(userId: string): number {
  let hash = 0;
  for (let i = 0; i < userId.length; i++) {
    hash = (hash * 31 + userId.charCodeAt(i)) | 0;
  }
  return Math.abs(hash) % AVATAR_SLOTS;
}
